import { gql } from 'graphql-tag'

const getBriefings = (categories: string[]) => {
  const categoriesStr = categories.map((cat) => `"${cat}"`).join(',')

  return gql`
    query getBriefings {
      allEvSales(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: [${categoriesStr}], field: SLUG}]}}
      ) {
        nodes {
          slug
          excerpt
          title
          date
          viewerCanRead
          __typename
          briefings {
            estimatedReadingTime
            publicationFrequency
          }
        }
      }
      automakerLeagueTables(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: [${categoriesStr}], field: SLUG}]}}
      ) {
        nodes {
          slug
          excerpt
          title
          date
          viewerCanRead
          __typename
          briefings {
            estimatedReadingTime
            publicationFrequency
          }
        }
      }
      batterySnapshots(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: [${categoriesStr}], field: SLUG}]}}
      ) {
        nodes {
          slug
          excerpt
          title
          date
          viewerCanRead
          __typename
          briefings {
            estimatedReadingTime
            publicationFrequency
          }
        }
      }
      batteryMineralsSnapshots(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: [${categoriesStr}], field: SLUG}]}}
      ) {
        nodes {
          slug
          excerpt
          title
          date
          viewerCanRead
          __typename
          briefings {
            estimatedReadingTime
            publicationFrequency
          }
        }
      }
      inventoryTrackers(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: [${categoriesStr}], field: SLUG}]}}
      ) {
        nodes {
          slug
          excerpt
          title
          date
          viewerCanRead
          __typename
          briefings {
            estimatedReadingTime
            publicationFrequency
          }
        }
      }
      rawMaterialPrices(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: [${categoriesStr}], field: SLUG}]}}
      ) {
        nodes {
          slug
          excerpt
          title
          date
          viewerCanRead
          __typename
          briefings {
            estimatedReadingTime
            publicationFrequency
          }
        }
      }
      supplyChainCapitalTrackers(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: [${categoriesStr}], field: SLUG}]}}
      ) {
        nodes {
          slug
          excerpt
          title
          date
          viewerCanRead
          __typename
          briefings {
            estimatedReadingTime
            publicationFrequency
          }
        }
      }
      profitabilityHeatmaps(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: [${categoriesStr}], field: SLUG}]}}
      ) {
        nodes {
          slug
          excerpt
          title
          date
          viewerCanRead
          __typename
          briefings {
            estimatedReadingTime
            publicationFrequency
          }
        }
      }
      energyTransitionCapitals(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: [${categoriesStr}], field: SLUG}]}}
      ) {
        nodes {
          slug
          excerpt
          title
          date
          viewerCanRead
          __typename
          briefings {
            estimatedReadingTime
            publicationFrequency
          }
        }
      }
      energyIndicators(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: [${categoriesStr}], field: SLUG}]}}
      ) {
        nodes {
          slug
          excerpt
          title
          date
          viewerCanRead
          __typename
          briefings {
            estimatedReadingTime
            publicationFrequency
          }
        }
      }
      eu2025VehicleEmissions(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: [${categoriesStr}], field: SLUG}]}}
      ) {
        nodes {
          slug
          excerpt
          title
          date
          viewerCanRead
          __typename
          briefings {
            estimatedReadingTime
            publicationFrequency
          }
        }
      }
      geoEconomicAndPolicyBriefings(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: [${categoriesStr}], field: SLUG}]}}
      ) {
        nodes {
          slug
          excerpt
          title
          date
          viewerCanRead
          __typename
          briefings {
            estimatedReadingTime
            publicationFrequency
          }
        }
      }
      regionalSnapshots(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: [${categoriesStr}], field: SLUG}]}}
      ) {
        nodes {
          slug
          excerpt
          title
          date
          viewerCanRead
          __typename
          briefings {
            estimatedReadingTime
            publicationFrequency
          }
        }
      }
      chinaBriefings(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: [${categoriesStr}], field: SLUG}]}}
      ) {
        nodes {
          slug
          excerpt
          title
          date
          viewerCanRead
          __typename
          briefings {
            estimatedReadingTime
            publicationFrequency
          }
        }
      }
      sustainabilityBriefings(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: [${categoriesStr}], field: SLUG}]}}
      ) {
        nodes {
          slug
          excerpt
          title
          date
          viewerCanRead
          __typename
          briefings {
            estimatedReadingTime
            publicationFrequency
          }
        }
      }
      countryRiskSnapshots(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: [${categoriesStr}], field: SLUG}]}}
      ) {
        nodes {
          slug
          excerpt
          title
          date
          viewerCanRead
          __typename
          briefings {
            estimatedReadingTime
            publicationFrequency
          }
        }
      }
    }
  `
}

export default getBriefings
